<template>
  <CDropdown theme="naked" type="container" v-model:active="expanded" :keepActive="keepExpanded" class="c-search-field">
    <template #toggle>
      <slot name="toggle">
        <CField ref="field" v-model="model" type="text" :label :placeholder :icon :disabled :required autocomplete="off" @focus.stop="onFocus" @click.stop="onFocus"/>
      </slot>
    </template>
    <template #default>
      <slot/>
    </template>
  </CDropdown>
</template>

<script setup lang="ts">
  import { ref, watch } from 'vue';
  import { cleanup, elementRef } from '../../utils/component';
  import viewEvents, { EscapePressed } from '../../view/viewEvents';
  import CDropdown from '../dropdown/CDropdown.vue';
  import CField from './CField.vue';

  const model = defineModel<string | null>();

  const props = defineProps<{
    label?: string;
    icon?: string;
    placeholder?: string;
    emptyLabel?: string;
    active?: boolean;
    keepExpanded?: boolean;
    disabled?: boolean;
    escapePriority?: number;
    required?: boolean;
  }>();

  /**
   * related to but not the same as the active prop
   * active = search active or results available
   * expanded = dropdown active
   */
  const expanded = ref(false);

  const field = elementRef();

  watch(() => props.active, v => {
    if (v !== expanded.value) expanded.value = v;
  });

  function onFocus(): void {
    if (props.active) expanded.value = true;
  }

  cleanup(viewEvents.on(EscapePressed, e => {
    if (expanded.value) {
      expanded.value = false;
      field.value?.querySelector('input')?.blur();
      e.handled = true;
    }
  }, props.escapePriority ?? 400));
</script>

<style lang="scss">
.c-search-field {
  .c-dropdown-toggle {
    display: block;
    padding: 0;
    cursor: auto;
    pointer-events: none;

    input {
      pointer-events: all;
    }
  }
}
</style>